import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgSmsTemplates,
  createOrgSmsTemplate,
  updateOrgSmsTemplate,
  deleteOrgSmsTemplate,
} from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgSmsTemplatesRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_SMS_TEMPLATES_REQUEST);
    try {
      var response = yield call(getOrgSmsTemplates, request.payload);
      yield put(actions.getOrgSmsTemplatesSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgSmsTemplatesFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgSmsTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_SMS_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        createOrgSmsTemplate,
        request.payload.organization_guid,
        request.payload
      );
      yield put(actions.createOrgSmsTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.createOrgSmsTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgSmsTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_SMS_TEMPLATE_REQUEST);
    try {
      var response = yield call(
        updateOrgSmsTemplate,
        request.payload.guid,
        request.payload.organization_guid,
        request.payload
      );
      yield put(actions.updateOrgSmsTemplateSuccess(response.data));
    } catch (e) {
      yield put(actions.updateOrgSmsTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgSmsTemplateRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_SMS_TEMPLATE_REQUEST);
    try {
      yield call(
        deleteOrgSmsTemplate,
        request.payload.guid,
        request.payload.organization_guid
      );
      yield put(actions.deleteOrgSmsTemplateSuccess(request.payload.guid));
    } catch (e) {
      yield put(actions.deleteOrgSmsTemplateFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
